import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import styles from './Tooltip.module.scss';
import clsx from 'clsx';

const Tooltip = ({
  title = '',
  children,
  overlayClassName,
  overlayStyle,
  show = true,
  color = '',
  placement = 'top',
  ...rest
}) => {
  if (!show) return <>{children}</>;

  return (
    <AntdTooltip
      title={title}
      color="var(--user-dropdown-bg)"
      overlayStyle={overlayStyle}
      overlayClassName={clsx(styles.infoTooltip, overlayClassName)}
      placement={placement}
      {...rest}
    >
      <div> {children} </div>
    </AntdTooltip>
  );
};

export default Tooltip;
